import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {setCreateButton, setTitle} from "../actions/main";
import Loader from "../components/Loader";
import {EventsService} from "../services/EventsService";
import formater from "../helpers/formater";
import {CashService} from "../services/CashService";
import {Link} from "react-router-dom";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Chart} from 'primereact/chart';
import {ArtistService} from "../services/ArtistService";
import {Dropdown} from "primereact/dropdown";
import {SelectButton} from "primereact/selectbutton";

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

var dateOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
};

var dateMonthOptions = {
    year: 'numeric',
    month: 'numeric',
    // day: 'numeric'
};

var dateYearOptions = {
    year: 'numeric',
    // month: 'numeric',
    // day: 'numeric'
};


function Analitic() {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [date, setDate] = useState(() => {
        if (localStorage.getItem('analytic_date')) {
            return new Date(parseInt(localStorage.getItem('analytic_date')))
        } else {
            return new Date()
        }
    })
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [events, setEvents] = useState(false)
    const [receipt, setReceipt] = useState(false)
    const [needRange, setNeedRange] = useState(true)

    const [firstDate, setFirstDate] = useState(new Date())
    const [secondDate, setSecondDate] = useState(new Date())


    const [labels, setLabels] = useState([])
    const [artists, setArtists] = useState([])
    const [currentArtist, setCurrentArtist] = useState(false)
    const [dataType, setDataType] = useState('dohod')
    const [rangeType, setRangeType] = useState('days')

    const [firstSectionView, setFirstSectionVIew] = useState('bar')
    const [secondSectionView, setSecondSectionVIew] = useState('bar')

    const [firstEvents, setFirstEvents] = useState([])
    const [secondEvents, setSecondEvents] = useState([])


    const getDates = (startDate, stopDate) => {
        let dateArray = [];
        let currentDate = startDate;
        let hasDates = []

        if (rangeType === 'days') {
            while (currentDate <= stopDate) {
                dateArray.push(new Date(currentDate));
                currentDate = currentDate.addDays(1);
            }
        }
        if (rangeType === 'month') {
            while (currentDate <= stopDate) {
                if (hasDates.indexOf(currentDate.toLocaleString('ru', dateMonthOptions)) === -1) {
                    hasDates.push(currentDate.toLocaleString('ru', dateMonthOptions))
                    dateArray.push(new Date(currentDate))
                }
                currentDate = currentDate.addDays(1)
            }
        }
        if (rangeType === 'year') {
            while (currentDate <= stopDate) {
                if (hasDates.indexOf(currentDate.toLocaleString('ru', dateYearOptions)) === -1) {
                    hasDates.push(currentDate.toLocaleString('ru', dateYearOptions))
                    dateArray.push(new Date(currentDate))
                }
                currentDate = currentDate.addDays(1)
            }
        }
        console.log('days', dateArray)
        return dateArray;
    }


    const updateData = (params) => {
        EventsService.GetList({filter: {client_id: currentDepartment}}).then((res) => {
            let arr = []
            console.log('events', res.items)
            // res.items.map((el) => {
            //     if(new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()){
            //         arr.push(el)
            //     }
            // })
            setEvents(res.items)
            setLoading(false)
        })
        ArtistService.GetList(params, '').then((response, h) => {

            // if (response.items) {
            setArtists(response.items)

        })
        CashService.GetList({client_id: currentDepartment, limit: 100000}).then((res) => {
            console.log('receipt', res.items)
            setReceipt(res.items)
            setLoading(false)
        })
    }

    useEffect(() => {
        setLoading(true)
        dispatch(setTitle(''))
        // dispatch()
        dispatch(setCreateButton(false))
        updateData()

    }, [currentDepartment, date]);


    // Отдел операции совпадает с текущим (пустой отдел у операции или на странице = подходит всем)
    const sameDept = (r) => currentDepartment === null || currentDepartment === undefined || currentDepartment === ''
        || r.client_id === null || r.client_id === undefined || Number(r.client_id) === Number(currentDepartment)

    const ticketAmount = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost).map((r) => {
                am += r.amount
            })
        }
        return am
    }
    const ticketAmountBlack = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost && r.type === 'rub').map((r) => {
                am += r.amount
            })
        }
        return am
    }

    const rao = (event) => {
        return ticketAmount(event) / 100 * 5
    }

    const fee = (event) => {
        return (ticketAmount(event) - ticketAmountBlack(event)) / 100 * 6
    }

    const eventFeeAmount = (event) => {
        if (event.artist_fee_correct) {
            return event.artist_fee_correct
        }
        if (event.artist_fee_type === 2) {
            return ticketAmount(event) / 100 * event.artist_fee
        } else {
            return event.artist_fee
        }
    }


    function isInt(value) {
        if (isNaN(value)) {
            return false;
        }
        var x = parseFloat(value);
        return (x | 0) === x;
    }

    const dohod = (event, type = false) => {

        let d = 0

        if ((dataType === 'dohod' && type === false) || type === 'dohod') {
            d = ticketAmount(event) - eventFeeAmount(event) - event.raider_b - event.raider_t - fee(event) - event.sound - event.rao
        }

        if ((dataType === 'rest' && type === false) || type === 'rest') {
            d = event.restaurant
        }

        if ((dataType === 'tickets' && type === false) || type === 'tickets') {
            d = event.ticket_sale
        }


        if (isInt(d)) {
            return d
        } else return 0;
    }


    useEffect(() => {


        let dataLabels = []
        let chartDatasets = []
        let chartDatasetsSecond = []

        let firstEvents = []
        let secondEvents = []

        if (firstDate.length === 2 && secondDate.length === 2 && secondDate[1] && firstDate[0]) {

            let dates = getDates(firstDate[0], firstDate[1])


            dates.map((date, k) => {

                let month = date.getMonth()

                if (rangeType === 'days') {
                    dataLabels.push([date.toLocaleString("ru", dateOptions)])
                }

                if (rangeType === 'month') {
                    dataLabels.push([date.toLocaleString("ru", dateMonthOptions)])
                }

                if (rangeType === 'year') {
                    dataLabels.push([date.toLocaleString("ru", dateYearOptions)])
                }

                let dateDohod = 0
                let filterEvents = events.filter((event) => {

                    let d = new Date(event.date)

                    if (rangeType === 'days') {
                        if (d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {

                            if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                return true
                            }
                        }
                    }

                    if (rangeType === 'month') {
                        if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {

                            if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                return true
                            }
                        }
                    }
                    if (rangeType === 'year') {
                        if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {

                            if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                return true
                            }
                        }
                    }
                });



                filterEvents.map((event) => {
                    dateDohod += dohod(event)
                    firstEvents.push(event)
                })

                chartDatasets.push(dateDohod)

            })


            if(needRange) {
                let datesSecond = getDates(secondDate[0], secondDate[1])

                datesSecond.map((date, k) => {

                    let month = date.getMonth()
                    if (typeof dataLabels[k] !== 'undefined') {

                        if (rangeType === 'days') {
                            dataLabels[k].push(date.toLocaleString("ru", dateOptions))
                        }

                        if (rangeType === 'month') {
                            dataLabels[k].push(date.toLocaleString("ru", dateMonthOptions))
                        }

                        if (rangeType === 'year') {
                            dataLabels[k].push(date.toLocaleString("ru", dateYearOptions))
                        }

                    } else {

                        if (rangeType === 'days') {
                            dataLabels.push(['', date.toLocaleString("ru", dateOptions)])
                        }

                        if (rangeType === 'month') {
                            dataLabels.push(['', date.toLocaleString("ru", dateMonthOptions)])
                        }

                        if (rangeType === 'year') {
                            dataLabels.push(['', date.toLocaleString("ru", dateYearOptions)])
                        }

                    }

                    let dateDohod = 0
                    let filterEvents = events.filter((event) => {

                        let d = new Date(event.date)

                        if (rangeType === 'days') {
                            if (d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {
                                if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                    return true
                                }
                            }
                        }

                        if (rangeType === 'month') {
                            if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {
                                if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                    return true
                                }
                            }
                        }

                        if (rangeType === 'year') {
                            if (d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear()) {
                                if ((currentArtist && currentArtist == event.artist_id) || !currentArtist) {
                                    return true
                                }
                            }
                        }

                    })


                    filterEvents.map((event) => {
                        dateDohod += dohod(event)
                        secondEvents.push(event)
                    })

                    chartDatasetsSecond.push(dateDohod)
                })
            }
        }


        let dataSets = chartData.datasets
        setFirstEvents(firstEvents)
        setSecondEvents(secondEvents)
        // console.log(dataSets)

        if(needRange) {
            setChartData({
                ...chartData,
                labels: dataLabels,
                datasets: [{...chartData.datasets[0], data: chartDatasets, type: firstSectionView}, {
                    ...chartData.datasets[1],
                    data: chartDatasetsSecond,
                    type: secondSectionView,
                    label: '2 сегмент',
                    backgroundColor: '#FFA726',
                }]
            })
        } else {
            setChartData({
                ...chartData,
                labels: dataLabels,
                datasets: [{...chartData.datasets[0], data: chartDatasets, type: firstSectionView}]
            })
        }


    }, [firstDate, secondDate, currentArtist, dataType, rangeType, firstSectionView, secondSectionView, needRange]);


    const handleScroll = (e) => {
        // if(!loading) {
        // localStorage.setItem('analyz_scroll', window.pageYOffset)
        // }
    }

    useEffect(() => {
        // alert(localStorage.getItem('events_scroll'))
        if (localStorage.getItem('analyz_scroll')) {
            window.scrollTo({top: parseInt(localStorage.getItem('analyz_scroll')), behavior: "smooth"});
        }
    }, [events]);


    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
        // Remove listener when component unmounts
        // window.removeEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        }
    }, [])

    const getRazClasses = (k) => {
        if (chartData.datasets[1].data[k] - chartData.datasets[0].data[k] > 0) {
            return 'r-plus';
        } else {
            return 'r-minus';
        }
    }


    const [chartData, setChartData] = useState({
        labels: labels,
        datasets: [{
            type: firstSectionView,
            label: '1 сегмент',
            backgroundColor: '#7dc006',
            data: [],
            // borderColor: 'white',
            // borderWidth: 2
        }, {
            type: secondSectionView,
            label: '2 сегмент',
            backgroundColor: '#FFA726',
            data: [],
            // borderWidth: 2
        }]
    });

    const [lightOptions] = useState({
        maintainAspectRatio: false,
        aspectRatio: .6,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    });

    const getCountTickets = (events) => {
        return events.reduce((partialSum, a) => partialSum + a.ticket_sale, 0)
    }

    const getRestaurant = (events) => {
        return events.reduce((partialSum, a) => partialSum + a.restaurant, 0)
    }

    const getDohod = (events) => {
        return events.reduce((partialSum, a) => partialSum + dohod(a, 'dohod'), 0)
    }

    return (
        <>

            <div className="d-flex align-items-center justify-content-between p-t-10">
                <h1>{'Аналитика'}</h1>

                <div>
                    <Dropdown placeholder={'Выберите артиста'} options={artists.map((artist) => {
                        return {
                            value: artist.id,
                            label: artist.name
                        }
                    })} filter={true} value={currentArtist} onChange={(e) => {

                        let dateFrom = new Date()
                        let dateTo = new Date()
                        let ev = events.filter((event) => event.artist_id === e.value)

                        ev.map((el) => {

                            if(new Date(el.date).getTime() < dateFrom.getTime()){

                                dateFrom = new Date(Date.parse(el.date));
                            }
                            if(new Date(el.date).getTime() > dateTo.getTime()){

                                dateTo = new Date(Date.parse(el.date));
                            }
                        })
                        if(e.value) {
                            setNeedRange(false)
                        } else {
                            setNeedRange(true)
                        }
                        setFirstDate([dateFrom, dateTo])
                        setSecondDate([dateFrom, dateTo])
                        setCurrentArtist(e.value)
                    }}
                              showClear={true}/>
                </div>


            </div>

            <div className="card analytic-filter">
                <div className="card-body">
                    <div className={'row'}>
                        <div className={'col-5'}>
                            <div>Первый сегмент</div>

                            <div className={'d-flex justify-content-between gap-3'}>
                                <Calendar value={firstDate} showOtherMonths={false} hideOnDateTimeSelect={true}
                                          onChange={(e) => setFirstDate(e.value)} selectionMode={'range'}
                                          numberOfMonths={3}
                                          showIcon={true}/>

                                <SelectButton className={'flex-shrink-0'} optionLabel="name" optionValue="value"
                                              options={[
                                                  {name: 'Бар', value: 'bar'},
                                                  {name: 'Линия', value: 'line'},
                                              ]} value={firstSectionView} onChange={(e) => {

                                    setFirstSectionVIew(e.value)
                                }
                                }/>
                            </div>
                        </div>
                        <div className={'col-5 offset-2'}>
                            <div>Второй сегмент</div>
                            <div className={'d-flex justify-content-between gap-3'}>
                                <Calendar selectionMode={'range'} value={secondDate}
                                          onChange={(e) => setSecondDate(e.value)} showButtonBar={true}
                                          showOtherMonths={false} hideOnDateTimeSelect={true} numberOfMonths={3}
                                          showIcon={true}/>

                                <SelectButton className={'flex-shrink-0'} optionLabel="name" optionValue="value"
                                              options={[
                                                  {name: 'Бар', value: 'bar'},
                                                  {name: 'Линия', value: 'line'},
                                              ]} value={secondSectionView} onChange={(e) => {

                                    setSecondSectionVIew(e.value)
                                }
                                }/>
                            </div>


                        </div>
                    </div>


                    <div className="row mt-5">
                        <div className="col-5">
                            <div className="d-flex gap-5">

                                <div>
                                    <small>Прибыль</small>
                                    <h3>{formater.amountFormat(firstEvents.reduce((partialSum, a) => partialSum + dohod(a, 'dohod'), 0))}</h3>
                                </div>

                                <div>
                                    <small>Билеты</small>
                                    <h3>{firstEvents.reduce((partialSum, a) => partialSum + a.ticket_sale, 0)}</h3>

                                </div>

                                <div>
                                    <small>Ресторан</small>
                                    <h3>{formater.amountFormat(firstEvents.reduce((partialSum, a) => partialSum + a.restaurant, 0))}</h3>
                                </div>

                            </div>

                        </div>
                        <div className="col-5 offset-2">
                            <div className="d-flex gap-5">

                                <div>
                                    <small>Прибыль</small>
                                    <h3>{formater.amountFormat(getDohod(secondEvents))}</h3>
                                    <small className={(getDohod(secondEvents) - getDohod(firstEvents) > 0) ? 'r-plus' : 'r-minus'}>
                                        {(getDohod(secondEvents) - getDohod(firstEvents) > 0 ? '+' : '')}{formater.amountFormat(getDohod(secondEvents) - getDohod(firstEvents))}</small>

                                </div>

                                <div>
                                    <small>Билеты</small>
                                    <h3>{getCountTickets(secondEvents)}</h3>
                                    <small className={(getCountTickets(secondEvents) - getCountTickets(firstEvents) > 0) ? 'r-plus' : 'r-minus'}>
                                        {(getCountTickets(secondEvents) - getCountTickets(firstEvents) > 0 ? '+' : '')}{getCountTickets(secondEvents) - getCountTickets(firstEvents)}</small>
                                </div>

                                <div>
                                    <small>Ресторан</small>
                                    <h3>{formater.amountFormat(getRestaurant(secondEvents))}</h3>
                                    <small className={(getRestaurant(secondEvents) - getRestaurant(firstEvents) > 0) ? 'r-plus' : 'r-minus'}>
                                        {(getRestaurant(secondEvents) - getRestaurant(firstEvents) > 0 ? '+' : '')}{formater.amountFormat(getRestaurant(secondEvents) - getRestaurant(firstEvents))}</small>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="card">
                <div className="card-body">

                    {loading && <Loader/>}

                    <div className={'d-flex align-items-center justify-content-between'}>
                        <SelectButton optionLabel="name" optionValue="value" options={[
                            {name: 'Дни', value: 'days'},
                            {name: 'Месяцы', value: 'month'},
                            {name: 'Года', value: 'year'},
                        ]} value={rangeType} onChange={(e) => {

                            setRangeType(e.value)
                        }
                        }/>

                        <SelectButton optionLabel="name" optionValue="value" options={[
                            {name: 'Прибыль', value: 'dohod'},
                            {name: 'Билеты', value: 'tickets'},
                            {name: 'Ресторан', value: 'rest'},
                        ]} value={dataType} onChange={(e) => {

                            setDataType(e.value)
                        }
                        }/>
                    </div>

                    <Chart type="bar" data={chartData} options={lightOptions}/>


                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <h2>Сводка</h2>

                    <div className={'row mt-5'}>
                        <div className={'col-5'}>
                            <div className={'d-flex gap-3 align-items-center'}>
                                <strong>Первый сегмент</strong>
                                <span style={{
                                    backgroundColor: '#7dc006',
                                    width: '50px',
                                    height: '10px',
                                    display: 'block'
                                }}></span>
                            </div>
                            <table className={'table table-data table-bordered'}>
                                {chartData.labels.map((label, k) => {
                                    return (
                                        <tr>
                                            <td><small>{label[0]}</small></td>
                                            <td>
                                                <strong>
                                                    {chartData.datasets[0].data[k] !== null ? formater.amountFormat(chartData.datasets[0].data[k]) : ''}
                                                </strong>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </table>
                        </div>

                        {needRange &&
                        <div className={'col-5'}>
                            <div className={'d-flex gap-3 align-items-center'}>
                                <strong>Второй сегмент</strong>
                                <span style={{
                                    backgroundColor: '#FFA726',
                                    width: '50px',
                                    height: '10px',
                                    display: 'block'
                                }}></span>
                            </div>
                            <table className={'table table-data table-bordered'}>
                                {chartData.labels.map((label, k) => {
                                    if (label[1]) {
                                        return (
                                            <tr>
                                                <td><small>{label[1]}</small></td>
                                                <td>

                                                    <strong>
                                                        {chartData.datasets[1].data[k] !== '' ? formater.amountFormat(chartData.datasets[1].data[k]) : ''}
                                                    </strong>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })}
                            </table>
                        </div>
                        }

                        {needRange &&
                        <div className={'col-2'}>
                            <strong>Разница (S2-S1)</strong>

                            <table className={'table table-data table-bordered'}>
                                {chartData.labels.map((label, k) => {
                                    if (label[1]) {
                                        return (
                                            <tr>
                                                {/*<td>{label[0]}</td>*/}
                                                <td>
                                                    <strong className={getRazClasses(k)}>
                                                        {formater.amountFormat(chartData.datasets[1].data[k] - chartData.datasets[0].data[k])}
                                                    </strong>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })}
                            </table>
                        </div>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default Analitic